export const UNSENDABLE_SEGMENTS = [
    "status = 'Stale'",
    'Status = Bounced OR Status = Unsubscribed OR Status = Abuse',
    'Status = Stale',
];
